import List from '../lists/List'

export default class Slider extends List {
  _construct() {
    super._construct()
    this._autoResize = false
  }

  _init() {
    const isVertical = this._orientation === List.ORIENTATION.vertical

    this.wrapper.transitions = { [isVertical ? 'y' : 'x']: { duration: 0.6, delay: 0.1 } } // , timingFunction: 'ease'
    this._mainTransition = this.wrapper.transition(isVertical ? 'y' : 'x')
    this._mainTransition.on('finish', () => {
      if (this._isSetItems === true) {
        // this.signal('sliderReady', {previousIndex: 0, newIndex: 0, dataLength: this.items.length});
        this._isSetItems = false
      }
    })
  }

  set scrollOffset(num) {
    this._scrollOffset = num
  }

  get scrollOffset() {
    return this._scrollOffset || 280
  }

  set listRef(name) {
    this._listRef = name.toString()
  }

  get listRef() {
    return this._listRef
  }

  get currentRow() {
    return this.currentItem
  }

  get currentCellItem() {
    return this.currentItem.currentItem
  }

  setItems(items) {
    super.setItems(items)

    this._isSetItems = true

    if (this._mainTransition) {
      this._mainTransition.reset(0, 0)
    }
  }

  _indexChanged(obj) {
    super._indexChanged(obj)

    const { previousIndex, newIndex, dataLength } = obj

    if (previousIndex === newIndex) {
      return
    }

    const current = this.currentItem

    const isVertical = this._orientation === List.ORIENTATION.vertical
    const main = isVertical ? 'y' : 'x'
    const mainDim = isVertical ? 'h' : 'w'

    const scrollOffset = this.scrollOffset

    const controlPoint = this._mainTransition.targetValue
    const boundary = this[mainDim]
    const boundaryStart = scrollOffset - controlPoint

    let m = controlPoint

    if (previousIndex > newIndex) {
      if (newIndex > 0 && current[main] < controlPoint * -1 + scrollOffset) {
        m = scrollOffset - current[main]
      } else if (current[main] < boundaryStart) {
        m = 0
      }
    } else {
      if (
        newIndex < dataLength - 1 &&
        current[main] + current[mainDim] > controlPoint * -1 + (boundary - scrollOffset)
      ) {
        m = boundary - scrollOffset - (current[main] + current[mainDim])
      } else if (newIndex === dataLength - 1 && current[main] + current[mainDim] >= boundary) {
        m = boundary - (current[main] + current[mainDim])
      }
    }

    if (this._mainTransition.isRunning()) {
      this._mainTransition.reset(m, 0.12)
    } else {
      this._mainTransition.start(m)
    }

    // this._mainTransition.on("finish", () => {
    // 	this.signal('listIndex', obj);
    // });

    this.signal('changeRowIndex', obj)
  }
}
